import styles from './Slider.module.css';
export default function Slider({ label, value, onChange, displayValue }) {
    return (
        <div className={styles.sliderRow}>
        <span className={styles.sliderLabel}>{label}:</span>
        <input
            type="range"
            min="0"
            max="1"
            step="0.001"
            value={value}
            onChange={(e) => onChange(parseFloat(e.target.value))}
            className={styles.slider}
        />
        <span className={styles.sliderValue}>{displayValue}</span>
        </div>
    );
}